import axios from 'axios';
import _ from 'lodash';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    order_id : "",
    loaded : false,
    error : false,
    allLoaded : false,
    columns: [
        {
            key : "name",
            label : "filename",
            limit : 20,
            display : true,
            type: "external_link",
            link_key : "link",
        },
        {
            key : "customer.name",
            label : "customer",
            display : true,
        },
        {
            key : "invoice_number",
            label: "inv_number",
            display : true,
        },
        {
            key : "invoice_Date",
            label: "invoice_date",
            type: "date",
            display:true,
        },
        {
            key : "amount",
            label: "amount",
            display:true,
            type:"decimal"
        },
        {
            key : "discount",
            label: "discount",
            display:true,
            type:"decimal"
        },
        {
            key : "paid_date",
            label: "last_payment",
            type: "date",
            display:true,
        }
    ],
    workingOn: [],
})

  // getters
  const getters = {
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        if(state.allLoaded == false && state.loaded == false){
            if(state.order_id == "" && rootState.kooi.kooi != undefined && rootState.kooi.kooi.data != undefined && rootState.kooi.kooi.data.order_id != undefined){
                commit("order_id", rootState.kooi.kooi.data.order_id);
            }
            commit("loaded", false);
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/external/documents/order", {params : {kooi : rootState.kooi.id, type: "order"}}).then((response) => {
                    commit("set", response.data.data);
                commit("loaded", true);
            }).catch(error => {
                commit("error", true);
            })
        }
    },
  }

  // mutations
  const mutations = {
      set(state, data){
        state.list = data;
      },
      loaded(state, status){
          state.loaded = status;
      },
      order_id(state, order){
          state.order_id = order;
          state.loaded = false;
          state.error = false;
          state.list = [];
      },
      error(state, status){
          state.error = status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
